import { ApiHandler as makeReq } from "./ApiHandler";
import { FileUploadApiHandler as makeFileUploadReq } from "./ApiHandler";

const API_BASE = "cdktalentacquisition/api";

export default {
  addSEZCardDetails: employeeIdDetails => {
    return makeFileUploadReq({
      url: `${API_BASE}/addsezcarddetails`,
      method: "POST",
      data: employeeIdDetails
    });
  },
  getSezEmployeeList: () => {
    return makeReq({
      url: `${API_BASE}/getsezemployeelist`,
      method: "GET"
    });
  }
};
